import axios from "axios";
import {
  GetDevicesDto,
  GetAppSettings,
  UpdateAppSettings,
} from "./settings.types";
import { API_URL_DEVICES, API_URL_USERS } from "../apiURLS";

const getMySettings = async (): Promise<GetAppSettings> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.get<GetAppSettings>(
    `${API_URL_USERS}/app-settings`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      withCredentials: true,
    }
  );
  if (response) return response.data;
  throw new Error("No data received.");
};

const getDevices = async (): Promise<GetDevicesDto[]> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.get(`${API_URL_DEVICES}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    withCredentials: true,
  });
  if (response) return response.data;
  throw new Error("No data received.");
};

const updateMySettings = async (
  data: UpdateAppSettings
): Promise<GetAppSettings> => {
  const authToken = localStorage.getItem("daex-auth-token");
  if (!authToken) {
    throw Error();
  }
  const response = await axios.put<GetAppSettings>(
    `${API_URL_USERS}/app-settings`,
    data,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      withCredentials: true,
    }
  );
  if (response) return response.data;
  throw new Error("No data received.");
};

const settingsService = {
  getMySettings,
  updateMySettings,
  getDevices,
};
export default settingsService;
